import { Color, COLORS } from "../../consts";

export const getColor = (styles: Record<string, any>, color: Color) => {
  return {
    [styles.orange]: !color,
    [styles.grey]: color === COLORS.GREY
  };
};
